import { PageHero } from "@/components/PageHero";
import { Lightning, Drop, Receipt, Calendar, Plug } from "@phosphor-icons/react";

const SECTIONS = [
  {
    icon: Receipt,
    title: "Bill Payments",
    points: [
      "Maintenance bills are issued by the 1st of every month, due by the 15th.",
      "Pay via the resident portal, NEFT or at the management office.",
      "A penalty of 2% / month applies on late payments.",
    ],
  },
  {
    icon: Lightning,
    title: "Electricity & Power",
    points: [
      "Each apartment has a dedicated BESCOM meter — bills go directly to the owner.",
      "DG backup covers lighting and 1 KW per apartment during outages.",
      "Common-area electricity is part of monthly maintenance.",
    ],
  },
  {
    icon: Drop,
    title: "Water & Plumbing",
    points: [
      "Water supply is metered per apartment via the central STP & RO system.",
      "Leakage reports are addressed within 24 hours by the in-house team.",
      "Tankers can be requested via the management WhatsApp group.",
    ],
  },
  {
    icon: Plug,
    title: "EV Chargers",
    points: [
      "Six shared chargers in basement B1 — 3.3 kW (slow) & 7.2 kW (fast).",
      "Slots can be booked via the residents app, 2-hour windows.",
      "Personal EV points are permitted with prior electrical approval.",
    ],
  },
  {
    icon: Calendar,
    title: "Office Holidays",
    points: [
      "The management office is closed on Sundays and 2nd Saturdays.",
      "Emergency security and helpdesk are available 24×7.",
      "Annual list shared on the residents portal in January.",
    ],
  },
];

const Info = () => (
  <div data-testid="info-page">
    <PageHero
      overline="For Residents"
      title={
        <>
          Information that
          <span className="italic text-brand-gold"> makes life easier.</span>
        </>
      }
      lead="Bills, utilities, office holidays and the small-print of day-to-day living at Exente."
      image="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto space-y-6">
        {SECTIONS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.title}
              data-testid={`info-section-${i}`}
              className="p-8 md:p-12 rounded-2xl border border-brand-sage bg-brand-sage/30 grid grid-cols-1 md:grid-cols-12 gap-8"
            >
              <div className="md:col-span-4 flex md:flex-col items-start gap-4">
                <Icon size={36} weight="light" className="text-brand-forest" />
                <h3 className="font-display text-3xl text-brand-forest">{s.title}</h3>
              </div>
              <ul className="md:col-span-8 space-y-3">
                {s.points.map((p, j) => (
                  <li
                    key={j}
                    className="flex gap-3 text-brand-mute leading-relaxed"
                  >
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-gold shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  </div>
);

export default Info;
